module.exports = __webpack_public_path__ + "static/media/img-3.41177c84.png";